import {
  events,
  selectors,
  formatStr,
  trackEvent
} from './analytics-helpers';

const trackSearchFilter = () => {
  const callback = event => {
    trackEvent({
      event: events.searchFilter,
      filter_text: formatStr(
        `${
          event
            .target
            .closest(selectors.searchFilterContainer)
            .querySelector(selectors.searchFilterTitle)
            .innerText
        } - ${
          event.target.value
        }`
      )
    });
  };
  const observer = new MutationObserver((mutations, observer) => {
    document.querySelectorAll(selectors.searchFilter).forEach(component => {
      component.addEventListener('change', callback);
    });
  });
  const observerTarget = document.querySelector(selectors.searchPageContainer);
  if (!observerTarget) {
    return
  }
  observer.observe(
    observerTarget,
    {
      subtree: true,
      childList: true
    }
  );
};

const trackSearchSort = () => {
  const sortCallback = event => {
    const options = document.querySelectorAll(selectors.searchSortOptions);

    trackEvent({
      event: events.searchSort,
      sort_text: formatStr(
        options.find(option => option.value === event.target.value).innerText
      )
    });
  };
  const careTypeCallback = event => {
    trackEvent({
      event: events.searchSort,
      sort_text: `care type - ${formatStr(event.target.value)}`
    });
  };
  const distanceCallback = event => {
    trackEvent({
      event: events.searchSort,
      sort_text: `distance - ${formatStr(event.target.value)}`
    });
  };
  const observer = new MutationObserver((mutations, observer) => {
    document.querySelectorAll(selectors.searchSort).forEach(component => {
      component.removeEventListener('change', sortCallback);
      component.addEventListener('change', sortCallback);
    });
    document.querySelectorAll(selectors.searchCareType).forEach(component => {
      component.addEventListener('change', careTypeCallback);
    });
    document.querySelectorAll(selectors.searchDistance).forEach(component => {
      component.addEventListener('change', distanceCallback);
    });
  });
  const observerTarget = document.querySelector(selectors.searchPageContainer);
  if (!observerTarget) {
    return
  }
  observer.observe(
    observerTarget,
    {
      subtree: true,
      childList: true
    }
  );
};

const trackSearchLabel = event => {
  const callback = event => {
    trackEvent({
      event: events.searchLabel,
      filter_label_text: formatStr(event.target.innerText),
      filter_label_article: formatStr(
        event.target
          .closest(selectors.searchResultItem)
          .querySelector(selectors.searchResultTitle)
          .innerText
      )
    });
  };
  const observer = new MutationObserver((mutations, observer) => {
    document.querySelectorAll(selectors.searchLabel).forEach(component => {
      component.removeEventListener('click', callback);
      component.addEventListener('click', callback);
    });
  });
  const observerTarget = document.querySelector(selectors.searchPageContainer);
  if (!observerTarget) {
    return
  }
  observer.observe(
    observerTarget,
    {
      subtree: true,
      childList: true
    }
  );
};

const trackSideNav = () => {
  document.querySelectorAll(
    `${selectors.sideNavSection} ${selectors.navLinkSubTitle}`
  ).forEach(component => {
    component.addEventListener('click', () => {
      trackEvent({
        event: events.navigation,
        nav_type: 'side nav',
        nav_text: formatStr(component.innerText),
        link_destination: component.href
      });
    });
  });
  document.querySelectorAll(
    `${selectors.sideNavSection} ${selectors.navLink}`
  ).forEach(component => {
    component.addEventListener('click', () => {
      trackEvent({
        event: events.navigation,
        nav_type: 'side nav',
        nav_text: `${formatStr(
          component
            .closest(selectors.sideNavSection)
            .querySelector(selectors.navLinkSubTitle)
            .innerText
        )} - ${formatStr(component.innerText)}`,
        link_destination: component.href
      });
    });
  });
};

const trackTopNav = () => {
  document.querySelectorAll(
    `${selectors.topNavSection} ${selectors.navLinkSubTitle}`
  ).forEach(component => {
    component.addEventListener('click', () => {
      trackEvent({
        event: events.navigation,
        nav_type: 'top nav',
        nav_text: `${formatStr(
          document
            .querySelector(selectors.navActiveDrawer)
            .innerText
        )} - ${formatStr(component.innerText)}`,
        link_destination: component.href
      });
    });
  });
  document.querySelectorAll(
    `${selectors.topNavSection} ${selectors.navLink}`
  ).forEach(component => {
    component.addEventListener('click', () => {
      const subtitle = component
        .closest(selectors.topNavSection)
        .querySelector(selectors.navLinkSubTitle);
      trackEvent({
        event: events.navigation,
        nav_type: 'top nav',
        nav_text: `${formatStr(
          document
            .querySelector(selectors.navActiveDrawer)
            .innerText
        )}${subtitle ? ` - ${formatStr(
          subtitle
            .innerText
        )}` : ''} - ${formatStr(component.innerText)}`,
        link_destination: component.href
      });
    });
  });
  document.querySelectorAll(
    `${selectors.topNavSupSection} ${selectors.topNavSupLink}`
  ).forEach(component => {
    component.addEventListener('click', () => {
      trackEvent({
        event: events.navigation,
        nav_type: 'top nav',
        nav_text: `${formatStr(
          document
            .querySelector(selectors.navActiveDrawer)
            .innerText
        )} - ${formatStr(
          component
            .closest(selectors.topNavSupSection)
            .querySelector(selectors.topNavSupTitle)
            .innerText
        )} - ${formatStr(component.innerText)}`,
        link_destination: component.href
      });
    });
  });
  let isFirstMutation = true;
  const observer = new MutationObserver((mutations, observer) => {
    if (!isFirstMutation) return;
    isFirstMutation = false;
    document.querySelectorAll(
      `${selectors.topNavSupSection} ${selectors.topNavSupCommunityLink}`
    ).forEach((component, index) => {
      component.addEventListener('click', () => {
        trackEvent({
          event: events.navigation,
          nav_type: 'top nav',
          nav_text: `${formatStr(
            document
              .querySelector(selectors.navActiveDrawer)
              .innerText
          )} - ${formatStr(
            component
              .closest(selectors.topNavSupSection)
              .querySelector(selectors.topNavSupTitle)
              .innerText
          )} - ${formatStr(component.innerText)}`,
          link_destination: component.href
        });
      });
    });
  });
  const observerTarget = document.querySelector(
    `${selectors.topNavSupSection} ${selectors.topNavSupCommunitySection}`
  );
  if (!observerTarget) {
    return
  }
  observer.observe(
    observerTarget,
    {
      subtree: true,
      childList: true
    }
  );
};

const trackFooterNav = () => {
  document.querySelectorAll(
    `${selectors.footerNavSection} ${selectors.footerNavLinkTitle}`
  ).forEach(component => {
    component.addEventListener('click', () => {
      trackEvent({
        event: events.navigation,
        nav_type: 'footer nav',
        nav_text: formatStr(component.innerText),
        link_destination: component.href
      });
    });
  });
  document.querySelectorAll(
    `${selectors.footerNavSection} ${selectors.footerNavLink}`
  ).forEach(component => {
    component.addEventListener('click', () => {
      trackEvent({
        event: events.navigation,
        nav_type: 'footer nav',
        nav_text: `${formatStr(
          component
            .closest(selectors.footerNavSection)
            .querySelector(selectors.footerNavLinkTitle)
            .innerText
        )} - ${formatStr(component.innerText)}`,
        link_destination: component.href
      });
    });
  });
  document.querySelectorAll(selectors.footerNavSocial).forEach(component => {
    component.addEventListener('click', () => {
      trackEvent({
        event: events.navigation,
        nav_type: 'footer nav',
        nav_text: formatStr(component.getAttribute('aria-label')),
        link_destination: component.href
      });
    });
  });
  document.querySelectorAll(selectors.footerNavUtilLink).forEach(component => {
    component.addEventListener('click', () => {
      trackEvent({
        event: events.navigation,
        nav_type: 'footer nav',
        nav_text: component.innerText,
        link_destination: component.href
      });
    });
  });
};

const trackLocationSearch = () => {
  const callback = () => {
    const term = formatStr(
      document.querySelector(selectors.locationSearchTerm).value
    );
    const careType = formatStr(
      document.querySelector(selectors.locationSearchCareTypeSelect).value
    );
    const termCriteria = term ? 'city, state, or zip' : '';
    const careTypeCriteria = careType ? 'care type' : '';
    trackEvent({
      event: events.locationSearch,
      search_country:
        formatStr(document.querySelector(selectors.locationSearchCountrySelect).value),
      search_location: term,
      search_caretype: careType,
      search_criteria:
        termCriteria || careTypeCriteria ? `${termCriteria}${
          termCriteria && careTypeCriteria ? ' - ' : ''
        }${careTypeCriteria}` : 'none seleted'
    });
  };
  document.querySelectorAll(selectors.locationSearchButton).forEach(component => {
    component.addEventListener('click', callback);
  });
  const keydownCallback = event => {
    if (event.keyCode === 13) {
      callback();
    }
  };
  const observer = new MutationObserver((mutations, observer) => {
    document.querySelectorAll(selectors.locationSearchTerm).forEach(component => {
      component.addEventListener('keydown', keydownCallback);
    });
  });
  const observerTarget = document.querySelector(selectors.locationSearchContainer);
  if (!observerTarget) {
    return
  }
  observer.observe(
    observerTarget,
    {
      subtree: true,
      childList: true
    }
  );
};

const trackHomepageContentButtons = () => {
  document.querySelectorAll(selectors.homepageContentButton).forEach(component => {
    component.addEventListener('click', () => {
      trackEvent({
        event: events.homepageContentButton,
        button_text:
          formatStr(component.innerText),
        button_status:
          component.getAttribute('aria-selected') !== 'true' ? 'open' : 'close'
      });
    });
  });
};

const trackFormStart = () => {
  document.querySelectorAll(selectors.contactUsForm).forEach(component => {
    const callback = () => {
      trackEvent({
        event: events.formStart
      });
      component.removeEventListener('input', callback);
    };
    component.addEventListener('input', callback);
  });
};

const trackCarouselLink = () => {
  const callback = event => {
    const link = event.target.closest('a');
    trackEvent({
      event: events.carousel,
      card_title: formatStr(
        link.querySelector(selectors.carouselLinkTitle).innerText
      ),
      cta_text: formatStr(
        link.querySelector(selectors.carouselLinkCta).innerText
      ),
      card_position: Number(
        link.closest('div').getAttribute('data-swiper-slide-index')
      ) + 1
    });
  };
  const observer = new MutationObserver((mutations, observer) => {
    document.querySelectorAll(selectors.carouselLink).forEach(component => {
      component.removeEventListener('click', callback);
      component.addEventListener('click', callback);
    });
  });
  const observerTarget = document.querySelector(selectors.carouselContainer);
  if (!observerTarget) {
    return
  }
  observer.observe(
    observerTarget,
    {
      subtree: true,
      childList: true
    }
  );
};

const trackCTACard = () => {
  document.querySelectorAll(selectors.ctaCard).forEach(component => {
    component.addEventListener('click', () => {
      trackEvent({
        event: events.ctaCard,
        card_title: formatStr(
          component.querySelector(selectors.ctaCardLinkTitle).innerText
        ),
        cta_text: formatStr(
          component.querySelector(selectors.ctaCardLinkLabel).innerText
        ),
        link_destination: component.href
      });
    });
  });
};

const trackCTALink = () => {
  document.querySelectorAll(selectors.ctaLink).forEach(component => {
    if (
      Object
        .keys(selectors)
        .some(
          key => selectors[key] !== selectors.ctaLink && component.matches(selectors[key])
        )
    ) {
      return;
    }
    component.addEventListener('click', () => {
      trackEvent({
        event: events.ctaLink,
        cta_text: formatStr(component.innerText) || 'not present',
        link_destination: component.href || 'not present'
      });
    });
  });
};

const trackCTAButton = () => {
  document.querySelectorAll(selectors.ctaButton).forEach(component => {
    if (
      Object
        .keys(selectors)
        .some(
          key =>
            selectors[key] !== selectors.ctaButton &&
            selectors[key] !== selectors.ctaLink &&
            component.matches(selectors[key])
        )
    ) {
      return;
    }
    component.addEventListener('click', () => {
      trackEvent({
        event: events.ctaButton,
        cta_text: formatStr(component.innerText),
        link_destination: component.href
      });
    });
  });
};

const trackQuickAccess = () => {
  document.querySelectorAll(selectors.quickAccess).forEach(component => {
    component.addEventListener('click', () => {
      trackEvent({
        event: events.quickAccess,
        quick_access_title: formatStr(
          component
            .closest(selectors.quickAccessContainer)
            .querySelector(selectors.quickAccessHeading)
            .innerText
        ),
        quick_access_text: formatStr(component.innerText)
      });
    });
  });
};

const trackFAQ = () => {
  let isFirstMutation = true;
  const observer = new MutationObserver((mutations, observer) => {
    if (!isFirstMutation) return;
    isFirstMutation = false;
    document.querySelectorAll(selectors.faq).forEach(component => {
      component.addEventListener('click', () => {
        trackEvent({
          event: events.faq,
          faq_category: formatStr(component.innerText.replace(/\(.*\)/g, '')),
          faq_status:
            component.getAttribute('aria-expanded') === 'true' ? 'open' : 'close'
        });
      });
    });
  });
  const observerTarget = document.querySelector(selectors.faqOutterContainer);
  if (!observerTarget) {
    return
  }
  observer.observe(
    observerTarget,
    {
      subtree: true,
      childList: true
    }
  );
};

const trackFAQQuestion = () => {
  let isFirstMutation = true;
  const observer = new MutationObserver((mutations, observer) => {
    if (!isFirstMutation) return;
    isFirstMutation = false;
    document.querySelectorAll(selectors.faqQuestion).forEach(component => {
      component.addEventListener('click', () => {
        trackEvent({
          event: events.faqQuestion,
          faq_category: formatStr(
            component
              .closest(selectors.faqContainer)
              .querySelector(selectors.faq)
              .innerText
              .replace(/\(.*\)/g, '')
          ),
          faq_question: formatStr(component.innerText.replace('Q: ', ''))
        });
      });
    });
  });
  const observerTarget = document.querySelector(selectors.faqOutterContainer);
  if (!observerTarget) {
    return
  }
  observer.observe(
    observerTarget,
    {
      subtree: true,
      childList: true
    }
  );
};

const trackVideo = () => {
  document.querySelectorAll(selectors.videoPlayButton).forEach(component => {
    component.addEventListener('click', () => {
      const videoContainer = document.querySelector(selectors.videoContainer);
      trackEvent({
        event: events.video,
        video_status: 'play',
        video_provide:
          videoContainer.getAttribute('src').includes('wistia') ?
            'wistia' :
            'youtube',
        video_percent: '0',
        video_title: formatStr(document.querySelector(selectors.videoTitle).innerText),
        video_view: 1
      });
    });
  });
};

// Tracking events for the step form had to be moved to the step form module file since
// the events were firing after the form state change and the submit event is not being
// fired on the form
// see: src/js/modules/step-form.js:486
// Tracking events for the searches had to be moved to each search file, due to something
// blocking the search button events listeners to be called
// see:
// src/js/modules/resource-listing-row.js:677
const addTrackingEvents = () => {
  trackSearchFilter();
  trackSearchSort();
  trackSearchLabel();
  trackSideNav();
  trackTopNav();
  trackFooterNav();
  trackLocationSearch();
  trackHomepageContentButtons();
  trackFormStart();
  trackCarouselLink();
  trackCTACard();
  trackCTALink();
  trackCTAButton();
  trackQuickAccess();
  trackFAQ();
  trackFAQQuestion();
  trackVideo();
};

(() => {
  document.addEventListener('DOMContentLoaded', addTrackingEvents);
})();
